<doc-header></doc-header>
<router-outlet></router-outlet>
<footer
  class="flex flex-col items-center justify-center border-t border-solid border-gray-200 px-5 py-8 text-sm"
>
  <p class="text-center">
    Created out of laziness from constantly rebuilding the same generic
    components.
  </p>

  <p class="text-center">
    Code licensed under an
    <a
      class="underline"
      target="_blank"
      href="https://github.com/ngverse/ui/blob/main/LICENSE"
    >
      MIT-style License.</a
    >
  </p>
</footer>
